var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconFacebook = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6668",
    "data-name": "Path 6668",
    d: "M44,29.5A14.5,14.5,0,1,0,29.5,44,14.5,14.5,0,0,0,44,29.5ZM31.111,40.657v-7.4H33.8a1.611,1.611,0,1,0,0-3.222H31.111V27.352a1.611,1.611,0,0,1,1.611-1.611H34.87a1.611,1.611,0,1,0,0-3.222H32.722a4.833,4.833,0,0,0-4.833,4.833v2.685H25.2a1.611,1.611,0,1,0,0,3.222h2.685v7.4a11.278,11.278,0,1,1,3.222,0Z",
    transform: "translate(-15 -15)",
    fill: "#737bbb"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-facebook.c5dbe328.svg";
export { ForwardRef as ReactComponent };